<template>
    <div class="div" v-loading.fullscreen.lock="allLoading">
        <div class="div-c">
            <div class="topTitle">
                <img src="../../assets/logo.png" alt="">
                <h1>{{title}}</h1>
            </div>
            <div class="content">
                <div class="content-c">
                    <div class="title">
                        {{divTitle}}
                    </div>
                    <div class="divider"></div>
                    <div class="test">
                        <span class='gksj'>{{gksj}}</span>
                        <el-button @click="goDownload(true)" style="margin-right:50px" type="primary">下载PDF</el-button>
                    </div>

                    <div class="main">
                        <span class="main-c" @click="goDownload(false)">
                            {{divname}}
                        </span>
                    </div>

                </div>
            </div>
            <el-dialog v-model="pdfDialog" custom-class="pdfDialog" width="80%" top='3vh'>
                <div style="height:80vh;overflow-y: none;">
                    <iframe :src="pdfUrl" frameborder="0" width="100%" height="100%"></iframe>
                </div>
            </el-dialog>
            <el-dialog v-model="dialogVisible" width="80%" top='3vh'>
                <div style="height:80vh">
                    <iframe :src="url" @load="allLoading = false" frameborder="0" width="100%" height="100%"></iframe>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import { publicPdf, publicDiv, getPublic } from '@/api/public.js'
    import VueCookies from 'vue-cookies'
    import axios from 'axios'
    import { ElLoading } from 'element-plus'
    import { login } from "@/api/gk.js";

    export default {
        name: "index",
        data() {
            return {
                allLoading: true,
                htmlurl: window.location.origin,
                divname: '',
                divTitle: '',
                gksj: '',
                title: '',
                dw: '',
                bm: '',
                dialogVisible: false,
                url: '',
                pdfTitle: '',
                openType: this.$store.state.openType == 'js' ? '决算' : '预算',
                pdfDialog: false,
                pdfUrl: '',
                isBoolean: false,
                pdfload:false
            }
        },
        async created() {
            this.divid = this.$route.query.id;
            await this.getYear();
            await this.getDivList();
            await this.getHtmlurl();
        },
       
        mounted() {
            window.addEventListener('message', (ev) => {
                const isCreatePdf = ev.data.isCreatePdf || null;
                const createPdfData = ev.data.createPdfData || null;
                console.log(isCreatePdf, createPdfData)
                if (isCreatePdf) {
                    var blob = new Blob([createPdfData], { type: "application/pdf" });
                    var url = URL.createObjectURL(blob);
                    if (this.isBoolean) {
                        var link = document.createElement("a");
                        link.download = this.pdfTitle
                        link.href = url;
                        link.click();
                        this.pdfload.close()
                        this.pdfDialog = false
                    } else {
                        this.url = url
                        this.dialogVisible = true
                        this.pdfload.close()
                        this.pdfDialog = false
                    }
                }
            }, false);
        },
        methods: {
            async goDownload(boolean) {
                this.allLoading = true
                var that= this
                let host = window.location.host;
                let year = window.location.host.split(".")[1]
                if (host.indexOf('sdys.22ys') > -1 || host.indexOf('sdjs.21js') > -1) {
                    this.pdfload = ElLoading.service({
                        target: '.pdfDialog',
                        text: '加载中...',
                        background: '#fff',
                    })
                    this.isBoolean = boolean
                    var params = {
                        //session: VueCookies.get("session") ? VueCookies.get("session") : localStorage.getItem('session'),
                        //zone: VueCookies.get("zone") ? VueCookies.get("zone") : localStorage.getItem('zone'),
                        divid: this.divid,
                    }
                    axios({
                        method: 'post',//请求方法
                        data: JSON.stringify(params),
                        url: 'http://218.3.163.21:8193/' + (year=='21js' ? 'js' : 'main') +'/topdf?refresh=false',
                        responseType: 'blob',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                    }).then(res => {
                        var blob = new Blob([res.data], { type: "application/pdf" });
                        var url = URL.createObjectURL(blob);
                        if (boolean) {
                            var link = document.createElement("a");
                            link.download = that.pdfTitle
                            link.href = url;
                            link.click();
                        } else {
                            // window.open(url, "_blank");
                            that.url = url
                            that.dialogVisible = true
                        }
                    }).catch(async error => {
                        if (!VueCookies.get("session") && !localStorage.getItem('session') && !sessionStorage.getItem('session')) {
                            let res = await login({ id: "zxh", password: "1111" })
                            if (res.status == 0) {
                                sessionStorage.setItem("session", res.session)
                                that.pdfDialog = true
                                that.pdfUrl = window.location.origin + `/pdfHtml?divid=${that.divid}&type=public&refresh=true`
                            }
                        } else {
                            that.pdfDialog = true
                            that.pdfUrl = window.location.origin + `/pdfHtml?divid=${that.divid}&type=public&refresh=true`
                        }
                    })
                } else {
                    const query = {
                        id: this.divid,
                        download: boolean,
                        htmlurl: this.htmlurl,
                    }
                    let res = await publicPdf(query)
                    if (res.type == 'application/json') {
                        this.$alert('服务器繁忙或暂时维护，请稍后再试', '提示', {
                            confirmButtonText: '确定',
                            type: 'error',
                        });
                    } else {
                        var blob = new Blob([res], { type: "application/pdf" });
                        var url = URL.createObjectURL(blob);
                        if (boolean) {
                            var link = document.createElement("a");
                            link.download = this.pdfTitle
                            link.href = url;
                            link.click();
                        } else {
                            // window.open(url, "_blank");
                            this.url = url
                            this.dialogVisible = true
                        }
                    }
                }
                this.allLoading = false

            },
            async getHtmlurl() {
                if (this.htmlurl.indexOf("localhost") == -1) {
                    this.htmlurl += "/pdfHtml";
                } else {
                    let tertiaryDns = window.location.host.split(".")[1];
                    this.htmlurl = this.htmlurl.slice(0, this.htmlurl.indexOf(tertiaryDns));
                    this.htmlurl += `${tertiaryDns}.czyjsgk.com:2617/pdfHtml`;
                }
                this.htmlurl += `?divid=${this.divid}`;
            },
            async getDivList() {
                let res = await publicDiv({ id: this.divid });
                if (res.status == '9aa5e47366e74320a934e8ea8124db98') {
                    this.goBack()
                } else {
                    if (res.status == 0) {
                        let time = res.type == 0 ? this.dw : this.bm
                        this.pdfTitle = res.title
                        if (time) {
                            this.gksj = res.gksj ? this.gksj = '公开时间:' + res.gksj.substring(0, res.gksj.indexOf('T')) : '公开时间:' + time
                        } else {
                            this.gksj = res.gksj ? this.gksj = '公开时间:' + res.gksj.substring(0, res.gksj.indexOf('T')) : '未设置公开时间'
                        }
                        this.divTitle = res.divname
                        this.divname = res.type == 0 ?
                            `${res.year}年度${res.divname}${this.openType}` :
                            `${res.year}年度${res.divname}部门${this.openType}`
                    }
                    this.allLoading = false;
                }
            },
            async getYear() {
                let host = window.location.host;
                let prefix = host.split(".")[1];
                let query = {}
                query.code = host.split(".")[0]
                query.year = '20' + prefix.substring(0, 2);
                query.type = prefix.substring(2, 4)
                let publicRes = await getPublic(query)
                if (publicRes.status == '9aa5e47366e74320a934e8ea8124db98') {
                    this.goBack()
                } else {
                    if (publicRes.status == 0) {
                        var city = publicRes.province;
                        this.title = `${publicRes.name}${query.year}年部门${this.openType}公开`
                        publicRes.gksj.forEach(ele => {
                            if (ele.divtype == 0) {
                                this.dw = ele.date.substring(0, ele.date.indexOf('T'))
                            } else if (ele.divtype == 2) {
                                this.bm = ele.date.substring(0, ele.date.indexOf('T'))
                            }
                        })
                    }
                }
            },
            goBack() {
                this.$router.push({ name: '公开页面' })
            },
        },
    };
</script>
<style scoped>
    .div {
        background: url(../../assets/bg.png) no-repeat center;
        height: 100%;
        width: 100%;
    }

    .div-c {
        width: 80%;
        height: 100%;
        margin: 0 auto;
    }

        .div-c .topTitle {
            width: 100%;
            height: 15vh;
            display: flex;
            align-items: center;
            padding-left: 10px
        }

            .div-c .topTitle h1 {
                color: #fff;
                font-weight: normal;
                font-size: 24px;
            }

    .content {
        width: 80%;
        height: 70vh;
        position: absolute;
        bottom: 15vh;
        left: 50%;
        transform: translate(-50%,0);
        background: #F9F9F9;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .content-c {
        height: 80%;
        width: 70%;
    }

        .content-c .title {
            font-size: 32px;
            text-align: center;
            display: flex;
            justify-content: center;
        }

    .divider {
        width: 100%;
        height: 2px;
        background: #717171;
        margin: 5px 0 25px 0;
    }

    .test {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

        .test .gksj {
            margin-left: 50px;
            display: block;
        }

    .main {
        display: flex;
        justify-content: center;
        margin-top: 100px;
    }

    .main-c {
        font-size: 26px;
        border-bottom: 1px solid #000;
        cursor: pointer;
    }
</style>